<script setup>
import { reloadNuxtApp } from 'nuxt/app'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
})
const errorData = computed(() => {
  if (props?.error?.data) {
    if (typeof props.error.data === 'string') {
      return JSON.parse(props.error.data)
    }
    return props.error.data
  }

  return null
})
useHead({
  title: errorData.value ? errorData.value.title : '404 - Page not found',
})

const { setLocale } = useI18n()
setLocale(errorData.value ? errorData.value.language : 'de')

function home() {
  reloadNuxtApp({ path: '/de/' })
}

function reload() {
  reloadNuxtApp()
}
</script>

<template>
  <NuxtLayout name="default">
    <div class="row justify-content-center spacer-navigation spacer-footer">
      <div class="col-12 col-800-8">
        <div class="d-flex flex-column">
          <h1 class="scale-6 scale-6--bold-uppercase">
            {{ error.message }}
          </h1>
        </div>
      </div>
      <div class="col-12 col-800-8">
        <FormButton
          :label="$t('error.reload')"
          style="margin-right: 10px"
          @click="reload"
        />
        <FormButton
          class="back-to-home"
          :label="errorData ? errorData.buttonText : 'Back'"
          component="NuxtLink"
          @click="home"
        />
      </div>
    </div>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.back-to-home {
  margin-top: clamp(40px, 0.35vw + 38.89px, 45px);
}
</style>
